module.exports = __webpack_public_path__ + "static/media/Graphs.e97873a9.png";